import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router-dom";

/** Public auth frame shared by login, signup, reset, verify and invitation pages. */
export function AuthLayout({ title, subtitle, children, footer, width = 400 }: {
  title: string; subtitle?: string; children: ReactNode; footer?: ReactNode; width?: number;
}) {
  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "background.default", p: 2 }}>
      <Stack spacing={2} sx={{ width: "100%", maxWidth: width }}>
        <Typography variant="h5" color="primary" textAlign="center" component={RouterLink} to="/" sx={{ textDecoration: "none" }}>
          CloudForge ERM
        </Typography>
        <Card>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h5" gutterBottom>{title}</Typography>
            {subtitle && <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{subtitle}</Typography>}
            {children}
          </CardContent>
        </Card>
        {footer && <Typography variant="body2" textAlign="center" color="text.secondary">{footer}</Typography>}
        <Typography variant="caption" textAlign="center" color="text.secondary">
          <Link component={RouterLink} to="/terms">Terms</Link> · <Link component={RouterLink} to="/privacy">Privacy</Link>
        </Typography>
      </Stack>
    </Box>
  );
}
